export default {
  showSnackBar: state => state.showSnackBar,
  success: state => state.success,
  snackBarMessage: state => state.snackBarMessage,
  color: state => state.color,
  snackBarHint: state => state.snackBarHint
}
